import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';

import { canPreviewVideoAsset, canRenameVideoAsset, getIsVideoAssetEditable, VideoAsset } from '../videoLibraryService';

import TablerDotsVertical from '@/studioComponents/Icons/tabler/TablerDotsVertical.vue';
import StudioButton from '@/studioComponents/StudioButton.vue';
import StudioDropdown, { MenuItem } from '@/studioComponents/StudioDropdown.vue';
import { isEURegion } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryTableItemQuickActions',
  props: {
    videoAsset: {},
    selected: { type: Boolean },
    openDirection: {},
    isProcessingDisabled: { type: Boolean, default: false }
  },
  emits: ["trigger:edit", "trigger:rename", "trigger:download", "trigger:download-seo-geo", "trigger:delete", "trigger:preview"],
  setup(__props: any, { emit }) {

const props = __props;





const menuItems = ref([
  {
    id: 0,
    title: 'Edit',
    hidden: isEURegion() || props.videoAsset.source === 'UPLOAD' || props.videoAsset.status === 'ERROR',
    disabled: !getIsVideoAssetEditable(props.videoAsset) || props.isProcessingDisabled,
    disabledReason: props.isProcessingDisabled
      ? 'Editing is unavailable for this event because Content Lab processing is disabled'
      : 'This video is not ready yet. Please try again after some time.'
  },
  {
    id: 1,
    title: 'Rename',
    disabled: !canRenameVideoAsset(props.videoAsset),
    disabledReason:
      props.videoAsset.status === 'ERROR' ? '' : 'This video is not ready yet. Please try again after some time.'
  },
  {
    id: 2,
    title: 'Download video',
    disabled: !props.videoAsset?.urls?.mp4,
    disabledReason:
      props.videoAsset.status === 'ERROR' ? '' : 'This video is not ready yet. Please try again after some time.'
  },
  {
    id: 3,
    title: 'Download SEO/GEO Assets',
    subTitle: 'Transcript and metadata to allow your video to be more discoverable by search engines and LLMs.',
    titleExtraClasses: 'tw-whitespace-nowrap',
    disabled: !props.videoAsset?.urls?.mp4,
    disabledReason:
      props.videoAsset.status === 'ERROR' ? '' : 'This video is not ready yet. Please try again after some time.'
  },
  {
    id: 4,
    title: 'Delete',
    hidden: ['EVENT_RECORDING', 'DIRECT_RECORDING'].includes(props.videoAsset.source ?? ''),
    disabled: props.selected || props.videoAsset.status === 'PROGRESSING',
    disabledReason:
      props.videoAsset.status === 'PROGRESSING'
        ? 'This video is not ready yet. Please try again after some time.'
        : 'Please deselect this video before deleting it from the library.'
  },
  {
    id: 5,
    title: 'Preview',
    disabled: !canPreviewVideoAsset(props.videoAsset),
    disabledReason:
      props.videoAsset.status === 'ERROR' ? '' : 'This video is not ready yet. Please try again after some time.'
  }
] as MenuItem[]);

const selectedItemIndex = ref(0);

const selectMenuItem = (id: number) => {
  if (id === 0) {
    emit('trigger:edit', props.videoAsset);
  } else if (id === 1) {
    emit('trigger:rename', props.videoAsset);
  } else if (id === 2) {
    emit('trigger:download', props.videoAsset);
  } else if (id === 3) {
    emit('trigger:download-seo-geo', props.videoAsset);
  } else if (id === 4) {
    emit('trigger:delete', props.videoAsset);
  } else if (id === 5) {
    emit('trigger:preview', props.videoAsset);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StudioDropdown, {
    useFixedPosition: "",
    isSlotEnabled: true,
    selectedItemIndex: selectedItemIndex.value,
    menuItems: menuItems.value,
    position: _ctx.openDirection,
    extraDropdownClasses: 'tw-w-80',
    onSelect: selectMenuItem
  }, {
    triggerButton: _withCtx(({ toggleDropdownMenu, setRef }) => [
      _createElementVNode("div", {
        class: "tw-rounded-lg tw-bg-white",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(StudioButton, {
          ref: el => setRef(el),
          trackingId: "video-library-table-item-quick-actions",
          variant: "outline",
          onClick: toggleDropdownMenu
        }, {
          icon: _withCtx(() => [
            _createVNode(TablerDotsVertical)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["selectedItemIndex", "menuItems", "position"]))
}
}

})